import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

export const getProcessLogsByRequestId = createAsyncThunk(
  "processLogs/getProcessLogsByRequestId",
  async (requestId: number, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/doc-process-logs/${requestId}`);
      return response.data; // Assuming the backend returns { status, message, data }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch process logs");
    }
  }
);
